import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {auth} from '../../firebase/firebase.utils';
import {selectCurrentUser} from '../../redux/user/user.selectors';
import './header.style.scss';


const TestHeader =({currentUser})=>(
    <div className='header'>
     
        <div className='options'>
             
               
      {
          currentUser? (  <div style={{display:'flex'}}>  
       <a className='option'href='https://firebasestorage.googleapis.com/v0/b/biocidiedukacija.appspot.com/o/materijal%20za%20polaganje%20isita%2FWEB%20ONLINE%20EDUKACIJA%20UPUTSTVO%202020.pdf?alt=media&token=a375f133-decf-4abc-aeaa-acd50a69b512' alt='test' target="_blank" rel="noopener noreferrer"  >УПУТСТВО ЗА ПОЛАГАЊЕ </a>
          <div className='option' onClick={()=> auth.signOut()} >ОДЈАВИ СЕ</div>
     </div>
          ) :(
          <div className='option'  ></div>
          )}


            </div>
            
    </div>
);

const mapStateToProps = createStructuredSelector({
currentUser:selectCurrentUser

});

export default connect(mapStateToProps)(TestHeader);